// state 初始值
const initialState = null

const ActionTypes = {
    ChangeDispatch:"change-dispatch",
    Clear:'clear',
    SetUse:"use",
}

export function ChangeDispatch(context){
    return {
        type:'change-dispatch',
        payload:context
    }
}

export function SetUse(context){
    return {
        type:'use',
        payload:context
    }
}

export function Clear(context){
    return {
        type:'clear',
        payload:context
    }
}
/**
 * @description 處理 Dispatch 相關的 reducer 
 * @param {object} state 狀態值，會給予一個初始值 initialState
 * @param {object} action 動作
 */
export default function DispatchReducer(state = initialState, action) {
    switch(action.type){
        case ActionTypes.ChangeDispatch:{
            let temp = {...state};
            Object.keys(action.payload).forEach(item=>{
                temp[item] = action.payload[item]
            })
            return temp
        }
        case ActionTypes.Clear:{
            return null
        }
        case ActionTypes.SetUse:{
            let temp = {...state};
            temp["isCopy"] = action.payload
            return temp
        }
        default:{
            return state
        }   
    }
}